import React, { useState, useEffect, useRef } from "react";
import { AdminStatusUpdate } from "../api/newprod";
import { getBids } from '../api/commerce';
import { useParams } from "react-router-dom";
import "../css/CreateForm.css";


const MAX_IMAGE_SIZE = 25 * 1024 * 1024;   // 25 MB
const MAX_VIDEO_SIZE = 250 * 1024 * 1024;  // 250 MB

const ProductForm = ({ product, onSave, onCancel }) => {
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [formValues, setFormValues] = useState({
    name: "",
    description: "",
    price: "",
    category: "",
    artist: "",
    material: "",
    style:"",
    feature_one: "",
    feature_two: "",
    length:"",
    width:"",
    height:"",
    weight:"",
    is_biddable: false,
    bidding_deadline: "",
    timezone: userTimezone,
    images: [],   
    videos: [],  
    status: "", 
    status_note: "",
  });

  const [images, setImages] = useState([]); 
  const [videos, setVideos] = useState([]); 
  const [bids, setbids] = useState([])
  const [error, setError] = useState("");
  const [consoleError, setConsoleError] = useState("");
  const mediaInputRef = useRef(null);
  const [selectStatusMode, setStatusMode] = useState({});
  const statusModesEn = {TBR:"TBR", open:"open", closed:"closed", sold:"sold", timedout:"timedout", removed:"removed"}

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])

  useEffect (() => {
    if (product.is_biddable) {
      getBids(product.id)
      .then (setbids)
      .catch(err => setConsoleError(err));
    }
  }, [product, product.is_biddable]);

  useEffect(() => {
    if (product) {
      setFormValues({
        name: product.name || "",
        description: product.description || "",
        price: product.price || "",
        category: product.category || "",
        artist: product.artist || "",
        material: product.material || "",
        feature_one: product.feature_one || "",
        feature_two: product.feature_two || "",
        length: product.length || "",
        width: product.width || "",
        height: product.height || "",
        weight: product.weight || "",
        style: product.style || "",
        delivered_by: product.delivered_by || "",
        pickup_address: product.pickup_address || "",
        is_biddable: product.is_biddable || false,
        bidding_deadline: product.bidding_deadline
          ? product.bidding_deadline.split("T")[0] // yyyy-MM-dd only
          : "",
        images: [],   
        videos: [],  
        timezone: userTimezone, 
        status: product.status || "",
        status_note: product.status_note || "",
      });
    }
  }, [product]);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === "checkbox") {
      setFormValues((prev) => ({ ...prev, [name]: checked }));
    } else if (type === "file") {
      setFormValues((prev) => ({
        ...prev,
        [name]: Array.from(files),
      }));
    } else {
      setFormValues((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleStatusMode = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
    setStatusMode(e.target.value);
  };
  
  const handleMediaChange = (e) => {
    setError("");
    const files = Array.from(e.target.files || []);
    const newImages = [];
    const newVideos = [];

    for (const file of files) {
      if (!file.type) {
        newVideos.push(file);
        continue;
      }

      if (file.type.startsWith("image/")) {
        if (file.size > MAX_IMAGE_SIZE) {
          if (setlang === "en") {
          setError(`Image "${file.name}" exceeds max size (${MAX_IMAGE_SIZE / (1024 * 1024)}MB).`);
          alert(`Image "${file.name}" exceeds max size (${MAX_IMAGE_SIZE / (1024 * 1024)}MB).`);
          } else {
          setError(`حجم عکس "${file.name}" بیشتر از حد مجاز (${MAX_IMAGE_SIZE / (1024 * 1024)}MB) است.`);
          alert(`حجم عکس "${file.name}" بیشتر از حد مجاز (${MAX_IMAGE_SIZE / (1024 * 1024)}MB) است.`);
          }          
          continue;
        }
        newImages.push(file);
      } else if (file.type.startsWith("video/")) {
        if (file.size > MAX_VIDEO_SIZE) {
          if (setlang === "en") { 
          setError(`Video "${file.name}" exceeds max size (${MAX_VIDEO_SIZE / (1024 * 1024)}MB).`);
          alert(`Video "${file.name}" exceeds max size (${MAX_VIDEO_SIZE / (1024 * 1024)}MB).`);
          } else {
          setError(`حجم ویدیو "${file.name}" بیشتر از حد مجاز (${MAX_VIDEO_SIZE / (1024 * 1024)}MB) است.`);
          alert(`حجم ویدیو "${file.name}" بیشتر از حد مجاز (${MAX_VIDEO_SIZE / (1024 * 1024)}MB) است.`);
          }
          continue;
        }
        newVideos.push(file);
      } else {
        if (setlang === "en") { 
        setError((prev) => prev + ` Unsupported file type: ${file.name}.`);
        } else {
        setError((prev) => prev + ` فرمت فایل غیر قابل پردازش ${file.name}.`);
        }      
      }
    }

    if (files.length > 5) {
      if (setlang === "en") {
        setError("You have exceeded maximum number of 5 files");
        alert("You have exceeded maximum number of 5 files");
      } else {
        setError("آگهی با بیش از ۵ عکس و یا ویدیو مجاز نمی‌باشد");
        alert("آگهی با بیش از ۵ عکس و یا ویدیو مجاز نمی‌باشد");
      }
    } else {
      setImages(newImages);
      setVideos(newVideos);
    }
  };

  const [existingImages, setExistingImages] = useState([]);
  const [existingVideos, setExistingVideos] = useState([]);
  const [deleteImages, setDeleteImages] = useState([]);
  const [deleteVideos, setDeleteVideos] = useState([]);

  useEffect(() => {
    if (product) {
      setExistingImages(product.images || []);
      setExistingVideos(product.videos || []);
    }
  }, [product]);


  const handleSubmit = async (e) => {
    e.preventDefault();

    if ((existingImages.length + existingVideos.length + images.length + videos.length) > 5) {
      if (setlang === "en") {
        setError("You have exceeded maximum number of 5 files");
        alert("You have exceeded maximum number of 5 files");
      } else {
        setError("آگهی با بیش از ۵ عکس و یا ویدیو مجاز نمی‌باشد");
        alert("آگهی با بیش از ۵ عکس و یا ویدیو مجاز نمی‌باشد");
      }
    } else {
      try {
        const scalarChanges = {};
        Object.entries(formValues).forEach(([key, value]) => {
          if (["images", "videos"].includes(key)) return; 
    
          let original = product ? product[key] : "";
          let current = value;
    
          if (key === "price") {
            original = Number(original);
            current = Number(current);
          }
          if (key === "is_biddable") {
            original = Boolean(original);
            current = Boolean(current);
          }
          if (key === "bidding_deadline") {
            original = product?.bidding_deadline
              ? product.bidding_deadline.split("T")[0]
              : "";
          }
    
          if (original !== current) {
            scalarChanges[key] = value;
          }
        });
    
        // 2. Check if media changes exist
        const hasMediaChanges =
          images.length > 0 || videos.length > 0 || deleteImages.length > 0 || deleteVideos.length > 0;
    
        // 3. If nothing changed, skip update
        if (Object.keys(scalarChanges).length === 0 && !hasMediaChanges) {
          alert(setlang==="en"?"No changes detected.":"تغییری در شناسه شما پیدا نشد");
          return;
        }
    
        // 4. If media changes → use FormData
        if (hasMediaChanges) {
          const data = new FormData();
    
          // Scalars
          Object.entries(scalarChanges).forEach(([key, value]) => {
            if (key === "price") {
              data.set(key, Number(value));
            } else if (key === "is_biddable") {
              data.set(key, value ? "true" : "false");
            } else if (key === "bidding_deadline" && value) {
              data.set(key, value + "T00:00:00Z");
            } else {
              data.set(key, value);
            }
          });
    
          // New uploads
          images.forEach((file) => data.append("images", file));
          videos.forEach((file) => data.append("videos", file));
    
          // Deletions
          deleteImages.forEach((id) => data.append("delete_images", id));
          deleteVideos.forEach((id) => data.append("delete_videos", id));
    
          await AdminStatusUpdate(product.id, data, true);
        } else {
          // JSON-only update
          const payload = {
            ...scalarChanges,
            price: scalarChanges.price ? Number(scalarChanges.price) : undefined,
            bidding_deadline: scalarChanges.bidding_deadline
              ? scalarChanges.bidding_deadline 
              : undefined,
          };
          await AdminStatusUpdate(product.id, payload, false);
        }
        onSave();
      } catch (error) {
        setConsoleError(error.response?.data ? JSON.stringify(error.response.data, null, 2) : error.message);
        alert(setlang==="en"?"Something went wrong, please try login again":"مشکلی رخ داد، لطفا دوباره وارد شو");
      }
    }
  };
  

  return (
    <div className="product-UpdateForm-container">
      
      <button onClick={onCancel} className="modal-close">&#10005;</button>

      {setlang === "en" ?
      <h3 className="product-form-title">Update Status</h3>:
      <h3 className="product-form-title">بازبینی وضعیت</h3>
      }

      <form className={setlang === "en" ? "Product-UpdateForm" : "Product-UpdateForm-fa" } onSubmit={handleSubmit}>
        <div className="delivered_by">
          <label >
            {setlang === "en" ?
              <select type="text" name="status" value={formValues.status} onChange={handleStatusMode} className="narrow_select" placeholder="Status" >
                <option value=""> "-- Select Article Mode --"</option>
                  {Object.keys(statusModesEn).map((cat, idx) => (
                <option key={idx} value={cat}> {cat} </option> ))}
              </select>
              :
              <select type="text" name="status" value={formValues.status} onChange={handleStatusMode} className="narrow_select" placeholder="Status" >
                <option value="">"-- تایین وضعیت --"</option>
                  {Object.keys(statusModesEn).map((cat, idx) => (
                <option key={idx} value={cat}> {cat} </option> ))}
              </select>
            }
          </label>
          {setlang === "en" ? (
            <label>
            <p style={{margin:"9px"}}>Provide status change note:</p>
              <input
                name="status_note"
                value={formValues.status_note}
                onChange={handleChange}
              />
            </label>
          ):(
            <label >
            <p style={{margin:"9px"}}>یادداشت</p>
              <input
                name="status_note"
                value={formValues.status_note}
                onChange={handleChange}
              />
            </label>
          )}
        </div>
        <div className="form-button-container">
          <button type="submit" className="butn-add">{setlang === "en" ? "Update Product" : "به روزرسانی آگهی" }</button>
          {product && (
            <button type="button" className="butn-remove" onClick={onCancel}>{setlang === "en" ? "Cancel" : "لغو" }</button>
          )}
        </div>

      </form>
    </div>
  );
};

export default ProductForm;
